const PcVersion = () => {
    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
            <div className="text-center">
                <h1 className="text-4xl font-bold text-blue-500 mb-6">
                    PC 버전을 다운로드하세요
                </h1>
                <a
                    href="https://ovwkxquc5843.edge.naverncp.com/Setup.exe"
                    className="px-6 py-3 bg-blue-500 text-white font-bold rounded hover:bg-blue-600 transition duration-300"
                    download
                >
                    다운로드
                </a>
            </div>
        </div>
    );
};

export default PcVersion;